/* eslint-disable */
import * as types from './action_types';
import Immutable from 'immutable';

export const initialState = Immutable.fromJS({
  loading: false,
  error: undefined,
  wordText: undefined,
  tackInterval: undefined,
  tacksCount: 0,
  pronunciationFile: undefined,
  exampleText: undefined,
  definitions: [],
  recommendedWords: [],
  isCheckpoint: undefined,
  isChat: undefined,
  readAt: undefined,
  slug: undefined,
  deliveryMethod: undefined,
  createdAt: undefined
});

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.TACK_NOTIFICATION_DETAILS_RESET:
      return initialState;
    case types.TACK_NOTIFICATION_DETAILS_RETRIEVING:
      return state.merge({ loading: true });
    case types.TACK_NOTIFICATION_DETAILS_RETRIEVED:
      return state.merge({ loading: false, error: undefined, ...action.tackNotificationDetails });
    case types.TACK_NOTIFICATION_DETAILS_MARKED_AS_READ:
      return state.merge({ readAt: Date.now() });
    case types.TACK_NOTIFICATION_DETAILS_ERROR:
      return state.merge({ error: action.error, loading: false });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/stores/tack_notification_details/reducer.js